import { Outlet, createFileRoute } from "@tanstack/react-router";
import { MessageChatCircle } from "@untitled-ui/icons-react";

import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/_panel/_messenger")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("messenger", context.tenant.modules);

    return {
      title: () => context.t("Messenger", { ns: "messenger.shared" }),
      hideCrumb: true,
      hideWidgets: true,
      crumb: [
        {
          Icon: MessageChatCircle,
        },
        {
          label: context.t("Messenger", { ns: "messenger.shared" }),
          link: { to: "/messenger" },
        },
      ],
    } satisfies ChildRouteContext;
  },
});

function Component() {
  return <Outlet />;
}
